/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./details-panel.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
export var DetailsPanel = function DetailsPanel() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.wrapper,
    backgroundColor: "elevation.surface"
  }, /*#__PURE__*/React.createElement(Image, null));
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 328,
    height: 597,
    viewBox: "0 0 328 597",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 32,
    rx: 3,
    fill: "#CCE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
    stroke: "#091E42",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 77,
    width: 253,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(280 68)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
    fill: "#091E42",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 121,
    width: 79,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 159,
    width: 114,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 197,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 235,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 273,
    width: 114,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 311,
    width: 110,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 349,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 387,
    width: 114,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 425,
    width: 114,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 463,
    width: 95,
    height: 6,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(178 112)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
    fill: "#4C9AFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 121,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 159,
    width: 98,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 188,
    width: 52,
    height: 20,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 195,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 230,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 239,
    r: 8,
    fill: "url(#pattern0_233_6342)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 236,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 273,
    width: 126,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 311,
    width: 126,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 349,
    width: 126,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 387,
    width: 126,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 425,
    width: 126,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 463,
    width: 126,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_233_6342",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_233_6342",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_233_6342",
    width: 400,
    height: 400,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
  })));
};